define('viewModels/privileged/qm/policies/editors/AgentIdSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'services/userService',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/policies/editors/AgentSelectorView'
], function (_, Promise, ko, userService, ViewModel, AgentSelectorView) {
    'use strict';

    /**
     * The AgentIdSelectorView class.
     * @class
     */
    var AgentIdSelectorView = function (agentIdsObservable) {
        var self = this;

        // This is just a wrapper around AgentSelector, and it merges up all
        // of the properties from that. Any exposed self.properties added to this
        // class have the potential to collide with properties from there, so avoid
        // if possible.
        var agentIds = agentIdsObservable;
        var agents = ko.observableArray();

        // Using 'new' instead of self.subView since everything from AgentSelectorView
        // will get merged up, this will include all of the cleanup. As long as
        // AgentIdSelectorView is created using self.subView, this is fine.
        var agentSelector = new AgentSelectorView(agents);

        _.merge(self, agentSelector);

        var agentPromises = _.map(agentIds(), function (agentId) {
            return userService.getUser(agentId);
        });

        Promise.all(agentPromises)
        .then(function (response) {
            _.each(response, function (selectedAgent) {
                agents.push(selectedAgent);
            });
        });

        self.computed(function () {
            var selectedAgentIds = _.map(self.agents(), 'id');
            agentIds(selectedAgentIds);
        });
    };

    return AgentIdSelectorView;
});

